export enum CheckoutIntegrationStatus {
	// sent to checkout integration
	SENT = 'sent',
	// checkout received
	RECEIVED = 'received',
	// checkout verified order
	VERIFIED = 'verified',
	// order is done on checkout
	FINALIZED = 'finalized',
	// rejected; e.g. technical issue
	REJECTED = 'rejected',
	// manually canceled by waiter
	CANCELED = 'canceled',
	// order is in queue because firetime has not come yet
	POSTPONED = 'postponed'
}
